import { z } from 'zod';
/**
 * Visão Geral. Na fundação a AttentionStrip já existe e é alimentada pela API —
 * cada milestone acrescenta seus próprios itens sem mexer no contrato.
 */
export const ATTENTION_KINDS = ['bad', 'warn', 'info'];
export const attentionKindSchema = z.enum(ATTENTION_KINDS);
export const attentionItemSchema = z.object({
    id: z.string(),
    kind: attentionKindSchema,
    text: z.string(),
    action: z.string(),
    /** Rota do admin para onde o operador é levado. */
    href: z.string(),
    count: z.number().int().nullable(),
});
export const overviewMetricSchema = z.object({
    key: z.string(),
    label: z.string(),
    value: z.string(),
    note: z.string().nullable(),
    tone: z.enum(['neutral', 'warn', 'bad', 'good']).default('neutral'),
});
export const overviewResponseSchema = z.object({
    attention: z.array(attentionItemSchema),
    metrics: z.array(overviewMetricSchema),
    /** Últimas ações da trilha de auditoria — "aconteceu hoje". */
    activity: z.array(z.object({
        id: z.string(),
        at: z.string(),
        text: z.string(),
    })),
});
/* ------------------------------ Busca global ------------------------------ */
export const SEARCH_ENTITIES = ['pessoa', 'usuario', 'centro-custo', 'plano-conta'];
export const searchEntitySchema = z.enum(SEARCH_ENTITIES);
export const searchResultSchema = z.object({
    id: z.string(),
    entity: searchEntitySchema,
    title: z.string(),
    subtitle: z.string().nullable(),
    href: z.string(),
});
export const searchQuerySchema = z.object({
    q: z.string().trim().min(2, 'Digite ao menos 2 caracteres').max(120),
    limit: z.coerce.number().int().min(1).max(30).default(12),
});
export const searchResponseSchema = z.object({ results: z.array(searchResultSchema) });
//# sourceMappingURL=dashboard.js.map